import React, { type FC, type HTMLAttributes, type ReactNode } from 'react'
import styles from './accordion.module.css'

export interface AccordionProps extends Omit<HTMLAttributes<HTMLDetailsElement>, 'onChange'> {
  defaultExpanded?: boolean
  expanded?: boolean
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void
  /** @deprecated Ignored - kept for MUI compat */
  elevation?: number
  /** @deprecated Ignored - kept for MUI compat */
  variant?: string
  disabled?: boolean
}

export const Accordion: FC<AccordionProps> = ({
  defaultExpanded = false,
  expanded,
  onChange,
  elevation: _elevation,
  variant: _variant,
  disabled,
  className,
  children,
  ...rest
}) => {
  const classes = [styles.accordion, disabled ? styles.disabled : undefined, className].filter(Boolean).join(' ')

  const handleToggle: React.ToggleEventHandler<HTMLDetailsElement> = e => {
    if (onChange) {
      onChange(e as unknown as React.SyntheticEvent, (e.target as HTMLDetailsElement).open)
    }
  }

  return (
    <details className={classes} open={expanded ?? defaultExpanded} onToggle={handleToggle} {...rest}>
      {children}
    </details>
  )
}

export interface AccordionSummaryProps extends HTMLAttributes<HTMLElement> {
  expandIcon?: ReactNode
}

export const AccordionSummary: FC<AccordionSummaryProps> = ({ expandIcon, className, children, ...rest }) => {
  const classes = [styles.summary, className].filter(Boolean).join(' ')

  return (
    <summary className={classes} {...rest}>
      <div className={styles.summaryContent}>{children}</div>
      {expandIcon ? <span className={styles.summaryIcon}>{expandIcon}</span> : null}
    </summary>
  )
}

export interface AccordionDetailsProps extends HTMLAttributes<HTMLDivElement> {}

export const AccordionDetails: FC<AccordionDetailsProps> = ({ className, children, ...rest }) => {
  const classes = [styles.details, className].filter(Boolean).join(' ')

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}
